// Chip de estado de un código o cupón: etiqueta propia en masculino, tono común del portal.
import { StatusPill } from '@/shared/patterns/Pills';
import { CODE_STATUS_TONE } from '../constants/discountCodes';
import type { CodeStatus } from '../lib/discountCodesList';
import { CODE_STATUS_LABEL } from '../lib/discountCodesRow';

export function CodeStatusBadge({ status }: { status: CodeStatus }) {
    return <StatusPill tone={CODE_STATUS_TONE[status]}>{CODE_STATUS_LABEL[status]}</StatusPill>;
}
